export default "__VITE_ASSET__CPkrFBON__"